import React from 'react';

import BannerImage from './BannerImage';

const JsonBanner = ({
	linkUrl,
	categoryName,
	campaignName,
	promotionImageName,
	staticPromotionImageName,
	staticPromotionCampaignName,
	isSplitBanner,
}) => {
	const isSplit = isSplitBanner === 'true';

	return (
		<div className="mb-4 text-center">
			<a
				href={`${linkUrl}?WT.ac=Lister|${categoryName}|Lister|1|${campaignName}`}
				target="_self"
				className="block"
				data-tag-name={`top-banner${isSplit ? '-1' : ''}`}>
				<BannerImage
					imageName={promotionImageName}
					campaignName={campaignName}
				/>
			</a>
			{isSplit && (
				<BannerImage
					imageName={staticPromotionImageName}
					campaignName={staticPromotionCampaignName}
					dataTagName="top-banner-2"
				/>
			)}
		</div>
	);
};

export default JsonBanner;
